import React from "react";
import { Container, Accordion, Row, Col } from "react-bootstrap";
const faqData = [
    {
        question:
            "Do you develop apps for both iOS and Android?",
        answer:
            "Yes. We build mobile applications for both iOS and Android, depending on the product requirements and the user base you need to support. We also work with cross-platform frameworks like Flutter and React Native when the goal is faster development and easier long-term maintenance.",
    },
    {
        question:
            "How do you decide between native and cross-platform development?",
        answer:
            "That depends on the app’s complexity, performance needs, timeline, and long-term product goals. We recommend an approach that fits the requirements best.",
    },
    {
        question:
            "How long does it take to build a mobile app?",
        answer:
            "Timelines depend on scope, features and platform choice, but most apps are developed in phases to deliver usable versions early.",
    },
    {
        question:
            "Do you handle backend integrations for mobile apps?",
        answer:
            "Yes. Mobile apps often rely on backend systems, APIs and third-party tools, and we make sure those integrations are reliable and well connected.",
    },
    {
        question:
            "How do you make sure the app stays usable over time?",
        answer:
            "We focus on usability, performance, regular updates, and long-term maintainability so the app continues to work well as needs change.",
    },
];

export default function FAQ() {
    return (
        <section className='padding-section-large faq-section'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">Frequently Asked <span className="text-gradient-1">Questions</span></h2>
                    </Col>
                </Row>
                <Accordion defaultActiveKey="0" flush>
                    {faqData.map((faq, index) => (
                        <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="faq-item"
                        >
                            <Accordion.Header>
                                {faq.question}
                            </Accordion.Header>
                            <Accordion.Body>
                                {faq.answer}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Container>
        </section>
    );
}